export default __webpack_public_path__ + "static/media/arrowRight.ed890157.svg";